import { render } from "./ListeReclamationPage.vue?vue&type=template&id=03bdcedc&ts=true"
import script from "./ListeReclamationPage.vue?vue&type=script&lang=ts"
export * from "./ListeReclamationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__